export default function useDataService() {
  const auditLogsHeaders = [
    {
      id: 1,
      label: 'ID',
      columnName: 'id',
      sx: { paddingLeft: 2 },
      size: 120,
    },
    { id: 2, label: 'Date', columnName: 'date', sx: { paddingLeft: 2 }, size: 280 },
    { id: 3, label: 'Actor', columnName: 'actor_email', sx: { paddingLeft: 2 } },
    { id: 4, label: 'Actor Role', columnName: 'actor_role', sx: { paddingLeft: 2 } },
    {
      id: 5,
      label: 'Partner',
      columnName: 'actor_reseller_name',
      sx: { paddingLeft: 2 },
    },
    { id: 6, label: 'Activity', columnName: 'activity', sx: { paddingLeft: 2 } },
    { id: 7, label: 'Source', columnName: 'source', sx: { paddingLeft: 2 } },
    { id: 8, label: 'Object', columnName: 'object_name', sx: { paddingLeft: 2 } },
    { id: 9, label: 'Object Type', columnName: 'object_type', sx: { paddingLeft: 2 } },
    {
      id: 10,
      label: 'Object Partner',
      columnName: 'object_reseller_name',
      sx: { paddingLeft: 2 },
    },
    { id: 11, label: 'Activity Status', columnName: 'status', sx: { paddingLeft: 2 } },
    { id: 12, label: 'Description', columnName: 'description', sx: { paddingLeft: 2 } },
  ];

  const statusOptions = [
    { id: 1, value: 'Success', title: 'Success' },
    { id: 2, value: 'Failed', title: 'Failed' },
  ];

  return { auditLogsHeaders, statusOptions };
}
